"use client"
import CallTempData from "@/Core/Bridge/CallTempData";
import {getToken, getUserId} from "@/app/utils/auth";
import {confJson} from "@/app/config/confJson";
import {defaultConfig} from "@/Fwk/Http/HttpConfig";
import {GameEntries, getGameItemDataId} from "@/app/(pages)/home/homeData";
import Util from "@/Master/Util";
import FrameOrientMgr from "@/Master/FrameOrient/FrameOrientMgr";
import {GameOrient} from "@/Master/FrameOrient/GameOrient";

type GameInitData={
    hot_fix_url: string,
    game_id: number,
    res_ver: string,
    host_name: string,
}

type GameLoginData={
    login_id:string;
    login_token:string;
    ext_info:string;
}

export class GameInitConfig {
    game_init_data!:GameInitData;
    version_data!:string;
    login_data!: GameLoginData;
    game_item_data!:GameEntries;//游戏入口

    constructor() {
        const gameId = CallTempData.getGameId;

        this.game_init_data = {
            hot_fix_url: "https://oss-gz-sc-zydown.oss-accelerate.aliyuncs.com/SlotGameCenterH5/slot_assets/version_1",
            game_id: gameId,
            res_ver: "1.0.0",
            host_name:confJson.h5_host_name,
        };

        this.version_data = "{\n    \"2e5921ca39e3042ea5ef81320e1f4500\":\"8a54bb668c450af3167bf7abc533a2ea\",\n    \"2fc4d08a64ce815370cbd531a9a616dd\":\"32c1883f95f48db2da3d4aa1a934c4eb\",\n    \"3c5ef246c55f0eb59663697d80ba1662\":\"8c3ac599b3b10b3583cd77ec09de1008\",\n    \"4e1c0f7d783431a480eb07da1d4d1135\":\"8eb4bbacb78832e822541c5cdffc24f1\",\n    \"6837e60d5729ac6789863cd921bbe8b9\":\"50902f3f7bec5ea0a221679d12363db8\",\n    \"73edee88e98539f5a438dd493df14588\":\"31099bd14043410d5851ed7da0b34b83\",\n    \"75a930bb7d0b117e89b111d2b0478137\":\"cd988f51b3c08d21cbd12126a396456c\",\n    \"832b871e2795b53e8b70dec4fd951233\":\"77dd34dcba442adc3542caea41ab52e6\",\n    \"888cf4e4d92ac52d58acf9e971e77661\":\"958b5819c31bcef909320e1ed49b1b3c\",\n    \"ad045351f67e8035bff6f1d7bf14e5a7\":\"534fcd515a596d64e20a2937fc33bebd\",\n    \"ad390073daca4c94cd29295847de4316\":\"d03271b051acde1f90249dce56578918\",\n    \"b25a3fdf727964042aabf687d2bbfd2b\":\"32b4620da5d1048475b29eb3287952b7\",\n    \"b9dd1b5bb857a99f7191687b28e3b880\":\"f90460da02d00df36a927e014c03046d\",\n    \"ba46b4ca090ecc6854384705c7eb035d\":\"895cc7640f377556240118e5a09268bd\",\n    \"ba47e124bb4a45c17ffb1f7e5ca8123c\":\"2b6076b3a77d63fce6f0613539d82d3b\",\n    \"bd0a58489c98cdf7eec67a16e984bdaf\":\"30f5ef8853771cc7950437aea6541783\",\n    \"e01d26d3be4924d9c86485536ae85344\":\"e095b8d35035e210a0790d90d9da13b8\",\n    \"f1565e3820e9a636d01ee941162b95fe\":\"bdc9ba20cfc4fe0351526ee7b9e068d8\"\n}";

        const gameItem = getGameItemDataId(gameId);
        if (gameItem) {
            const itemData = Util.DeepClone(gameItem);
            const isHorizontal = FrameOrientMgr.isGetHorizontal;
            if (isHorizontal){
                //首次访问 横屏 默认设置横屏幕
                itemData.defaultDirection = GameOrient.Horizontal;
            }
            this.game_item_data = itemData;
        }

        this.login_data = {
            login_id: getUserId()+'',
            login_token: getToken(),
            ext_info: "null",
        };
    }

    public toString(){
        return JSON.stringify(this);
    }

}
